import React from "react";
import ReactDOM from "react-dom";
import App from './components/App';
import SnackbarProvider from 'react-simple-snackbar'
import './style.css';


ReactDOM.render(
      <SnackbarProvider>
        <App />
      </SnackbarProvider>,
  document.getElementById('root')
)
